import { action, makeObservable, observable } from 'mobx';

import { iframeService } from '../services/iframeService';

import { applicationStore } from './applicationStore';

import { NotificationsType } from '../core/constants/notificationsType';
import { setTranslationValues } from '../core/helpers/setTranslationValues';
import { timeHelperWithMinutesAndSecond } from '../core/helpers/timeHelper';

class NotificationStore {
  notificationTypes = [];

  notificationInfo = null;

  isMaintenance = false;

  maintenanceText = '';

  isMaintenanceStart = false;

  operatorError = null;

  constructor() {
    makeObservable(this, {
      notificationInfo: observable,
      maintenanceText: observable,
      operatorError: observable,
      isMaintenanceStart: observable,
      notificationTypes: observable.deep,
      hideNotification: action.bound,
      showNotification: action.bound,
      setMaintenanceText: action.bound,
      setIsMaintenance: action.bound,
      setOperatorError: action.bound,
      setNotificationTypes: action.bound,
      updateNotificationType: action.bound,
      setNotificationInfo: action.bound,
    });
  }

  setOperatorError(operatorError) {
    this.operatorError = operatorError;
  }

  setIsMaintenanceStart(bool) {
    this.isMaintenanceStart = bool;
  }

  setIsMaintenance(bool) {
    this.isMaintenance = bool;
  }

  setMaintenanceText(value) {
    this.maintenanceText = setTranslationValues(
      applicationStore.canvasTranslationKeys.MAINTENANCE,
      {
        VALUE: value,
      }
    );
  }

  setNotificationInfo(info) {
    this.notificationInfo = info;
  }

  setNotificationTypes(notificationTypes) {
    this.notificationTypes = notificationTypes;
  }

  showNotification({ type, notificationInfo }) {
    if (type === NotificationsType.Maintenance) {
      this.startUnderMaintenanceFunctional({ type, notificationInfo });
    } else {
      this.updateNotificationType({ type, notificationInfo });
      this.setNotificationInfo(notificationInfo);
    }
  }

  updateNotificationType(notificationInfo) {
    this.notificationTypes = [...this.notificationTypes, notificationInfo];
  }

  hideNotification = () => {
    const clearSpinResponseCode = this.notificationTypes.filter(
      (el) => el.type !== NotificationsType.SpinResponseCode
    );
    this.setNotificationTypes([...clearSpinResponseCode]);
    this.setOperatorError(null);
  };

  startUnderMaintenanceFunctional({ type, notificationInfo }) {
    if (this.isMaintenanceStart) {
      return;
    }
    this.setIsMaintenanceStart(true);
    const { startDate, notifySeconds } = notificationInfo || {};
    if (startDate) {
      this.setMaintenanceText(timeHelperWithMinutesAndSecond(notifySeconds));
      let seconds = Math.floor(
        (+new Date(`${startDate}${startDate.includes('Z') ? '' : 'Z'}`) - +new Date()) / 1000
      );
      let isFirst = true;

      if (!notifySeconds || (notifySeconds > seconds && seconds >= 0)) {
        if (isFirst) {
          isFirst = false;
          this.updateNotificationType({ type, notificationInfo });
        }
        this.setMaintenanceText(timeHelperWithMinutesAndSecond(seconds));
      }
      const interval = setInterval(() => {
        if (seconds >= 0) {
          if (!notifySeconds || notifySeconds >= seconds) {
            if (isFirst) {
              isFirst = false;
              this.updateNotificationType({ type, notificationInfo });
            }
            this.setMaintenanceText(timeHelperWithMinutesAndSecond(seconds));
          }
          seconds -= 1;
        } else {
          clearInterval(interval);
          iframeService.reloadFrame();
        }
      }, 1000);
    }
  }
}

export const notificationStore = new NotificationStore();
